<template>
  <div>
    <DateViewPicker
      :date="date"
      @dateChanged="dateChanged"
    />

    <div
      v-for="slot in slots"
      :key="slot"
    >
      <div class="px-3 py-2 m-2 inline-block border">
        {{ slot.time | moment("HH:mm") }}
      </div>
    </div>
  </div>
</template>

<script>
import DateViewPicker from '@/app/shared/components/date/dateViewPicker.vue';
import { ListAvailableSlots } from '@/app/shared/services/slotService/slotService';

export default {
  name: 'TeeTime',

  components: {
    DateViewPicker,
  },

  data() {
    return {
      date: new Date(),
      slots: undefined,
    };
  },

  computed: {

  },

  watch: {

  },

  created() {

  },

  mounted() {
    this.getAvailableSlots();
  },

  methods: {
    dateChanged(changedDate) {
      this.date = changedDate;
      this.getAvailableSlots();
    },

    getAvailableSlots() {
      ListAvailableSlots('4a80ee3f-21f0-4230-a207-08d87a935029', this.date).then((data) => {
        this.slots = data;
      });
    },
  },

};
</script>
